import { render, staticRenderFns } from "./ModalErrorMessage.vue?vue&type=template&id=01ec2b94&scoped=true&"
import script from "./ModalErrorMessage.vue?vue&type=script&lang=js&"
export * from "./ModalErrorMessage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01ec2b94",
  null
  
)

export default component.exports